<template>
  <div id="Dingweizoushi">
    <div class="tr-header">
      <p class="title">号码分布</p>
      <div class="handles" v-if="betType != 'xyrb'">
        <span
          @click="handleChecked('today', '0')"
          :class="{'checked': checked === '0'}"
          class="handle"
        >今天</span>
        <span
          @click="handleChecked('yesterday', '1')"
          :class="{'checked': checked === '1'}"
          class="handle"
        >昨天</span>
        <span
          @click="handleChecked('beforeYesterday', '2')"
          :class="{'checked': checked === '2'}"
          class="handle"
        >前天</span>
        <span
          @click="handleChecked('30', '3')"
          :class="{'checked': checked === '3'}"
          class="handle"
        >最近 30 期</span>
        <span
          @click="handleChecked('60', '4')"
          :class="{'checked': checked === '4'}"
          class="handle"
        >最近 60 期</span>
        <span
          @click="handleChecked('90', '5')"
          :class="{'checked': checked === '5'}"
          class="handle"
        >最近 90 期</span>
      </div>
    </div>
    <!-- <div class="tr-header">
      <p class="title">号码分布</p>
    </div>-->
    <div class="tr-table-container">
      <div class="check_box">
        <span>标注选择:</span>
        <CheckboxGroup v-model="showList" @on-change="checkAllGroupChange">
          <Checkbox label="yilou">遗漏</Checkbox>
          <!-- <Checkbox label="zhexian">折线</Checkbox> -->
          <Checkbox label="yifen">遗漏分成</Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="columns" :loading="isLoading" :data="dataSource" border></Table>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="lostColumns" :loading="isLoading" :data="lostList" border></Table>
      <div class="food_div">
        <p>总分大小： 8个开奖号码的数字的和值为总分；和值85~132为总分大， 36到83为总分小，和值为84打和；</p>
        <p>总分单双： 8个开奖号码的数字的和值为总分;总分值奇数为单，偶数为双；</p>
        <p>总分尾数： 8个开奖号码的数字的和值为总分;总分值的个位数大于等于5为总尾大，小于等于4为总尾小；</p>
        <p>遗漏期数：自上期开出到本期间隔的期数。</p>
        <p>出现次数：统计周期内，某个号码的累计出现次数。</p>
        <p>最大遗漏：是指统计周期内所有遗漏值的最大值。</p>
        <p>最大连出：是指统计周期内所有连出值的最大值</p>
      </div>
    </div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Dingweizoushi",
  data() {
    return {
      showList: ["yilou"],
      columns: [],
      pageSize: 30,
      dataSource: [],
      checked: "3",
      checkedButton: "6",
      ballIndex: 0,
      lostColumns: [],
      lostList: [],
      startDate: "",
      isLoading: false,
      divideList: []
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.getDate();
      }
    }
  },
  methods: {
    handleChecked(agt, index) {
      this.startDate = "";
      this.pageSize = "";
      this.checked = index;
      if (agt == "today") {
        this.startDate = dayjs().format("YYYY-MM-DD");
      } else if (agt == "yesterday") {
        // date -= 1;
        this.startDate = dayjs()
          .add(-1, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "beforeYesterday") {
        this.startDate = dayjs()
          .add(-2, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "30") {
        this.pageSize = 30;
      } else if (agt == "60") {
        this.pageSize = 60;
      } else if (agt == "90") {
        this.pageSize = 90;
      }
      this.getDate();
    },
    checkAllGroupChange() {
      var lostList = document.querySelectorAll(".lost_info");
      var canvas = document.querySelector(".cvs_container");
      var divide = document.querySelectorAll(".divide_lost_info");
      for (let i = 0; i < divide.length; i++) {
        const e = divide[i];
        e.parentNode.parentNode.classList.remove("lost_active");
      }
      if (!this.showList.includes("yilou")) {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];

          e.style.display = "none";
        }
      } else {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = "inline-block";
        }
      }
      if (this.showList.includes("yifen")) {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.add("lost_active");
        }
      } else {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.remove("lost_active");
        }
      }
    },
    handleChecked(agt, index) {
      this.startDate = "";
      this.pageSize = "";
      this.checked = index;
      if (agt == "today") {
        this.startDate = dayjs().format("YYYY-MM-DD");
      } else if (agt == "yesterday") {
        // date -= 1;
        this.startDate = dayjs()
          .add(-1, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "beforeYesterday") {
        this.startDate = dayjs()
          .add(-2, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "30") {
        this.pageSize = 30;
      } else if (agt == "60") {
        this.pageSize = 60;
      } else if (agt == "90") {
        this.pageSize = 90;
      }
      this.getDate();
    },
    handleBallChecked(i) {
      this.ballIndex = i;
      this.getDate();
    },
    reset(data) {
      this.columns = columns(this.betType, data, this.ballIndex).list(this);
      this.lostColumns = columns(this.betType, data, this.ballIndex).lostList(
        this
      );
    },
    async getDate() {
      let req = {
        gameType: this.$route.params.gameType,
        isNeed: 1,
        num: this.pageSize,
        date: this.startDate
      };
      this.isLoading = true;
      let res = await this.$http.post("/queryKcReportByIssue.do", req);
      if (res.data.returnCode == "0000") {
        this.isLoading = false;
        let arr;
        if (this.betType == "ks") {
          arr = format.formatKsDingwei(res.data.returnList, this.ballIndex);
        } else {
          arr = format.formatSscDingwei(res.data.returnList, this.ballIndex);
        }
        this.lostList = format.formatLost(res.data.returnMap);
        // console.log("thislostlist", this.lostList);
        this.formatLost(arr);
        this.dataSource = arr;

        this.reset(arr);
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatLost(arg) {
      //取得每一列遗漏数目
      this.divideList = arg[0].ball_json["numSpread"].nums;
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Haomafenbu/index.vue